<ng-container *ngIf="item.subItemsArray && !item.hidden">
  <ng-container *ngIf="depth < 1">
    <!-- first level expands on desktop and mobile -->
    <div class="item-title chevron" [ngClass]="{ 'chevron-toggled': item.isOpen }" (click)="toggleSubmenu(item)">
      {{ item.title | translate }}
    </div>
    <ul class="depth-{{ depth + 1 }}" *ngIf="item.isOpen">
      <li *ngFor="let subItem of item.subItemsArray; trackBy: trackByRoute">
        <xux-menu-item [item]="subItem" [depth]="depth + 1" (onTogglePin)="togglePin($event)"></xux-menu-item>
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="depth >= 1">
    <!-- second level and above will use popover on desktop... -->
    <div
      class="item-title chevron desktop-show"
      [class.active]="item.isOpen"
      (mouseleave)="mouseLeave($event)"
      (mouseenter)="mouseEnter($event)"
      (touchstart)="mouseEnter($event)"
    >
      <span (click)="clickPin(item, $event)" class="pin" [class.pinned]="item.pinned">
        <i class="icon-pin"></i>
      </span>
      {{ item.title | translate }}
      <ul class="popover-wrapper popover right depth-{{ depth + 1 }}" #popover>
        <li *ngFor="let subItem of item.subItemsArray; trackBy: trackByRoute" routerLinkActive="active">
          <xux-menu-item [item]="subItem" [depth]="depth + 1" (onTogglePin)="togglePin($event)"></xux-menu-item>
        </li>
      </ul>
    </div>
    <!-- ...and expand on mobile -->
    <div
      class="item-title chevron mobile-show"
      [ngClass]="{ 'chevron-toggled': item.isOpen }"
      (click)="toggleSubmenu($event)"
    >
      <span (click)="clickPin(item, $event)" class="pin" [ngClass]="{ pinned: item.pinned }">
        <i class="icon-pin"></i>
      </span>
      {{ item.title | translate }}
    </div>
    <ul class="mobile-show depth-{{ depth + 1 }}" *ngIf="item.isOpen">
      <li *ngFor="let subItem of item.subItemsArray; trackBy: trackByRoute" routerLinkActive="active">
        <xux-menu-item [item]="subItem" [depth]="depth + 1" (onTogglePin)="togglePin($event)"></xux-menu-item>
      </li>
    </ul>
  </ng-container>
</ng-container>

<div *ngIf="!item.subItemsArray" class="item-link">
  <a [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: item.exactActive }">
    <!-- <span *ngIf="" (click)="clickPin(item, $event);" class="pin" [ngClass]="{'pinned': item.pinned}">
      <i class="icon-pin"></i>
    </span> -->
    {{ item.title | translate }}<i *ngIf="item.icon" class="menu-item-icon glyphicon" [ngClass]="item.icon"></i>
  </a>
</div>
